// eslint-disable-next-line import/no-unassigned-import
import 'whatwg-fetch';
import React from 'react';
import {hydrate} from 'react-dom';
import {Provider} from 'react-redux';
import configureStore from './store/configureStore';
import PrequalForm from './components/PrequalForm';

const state = window.__STATE__;
delete window.__STATE__;
const store = configureStore(state)
hydrate(
    <Provider store={store}>
        <PrequalForm />
    </Provider>,
    document.querySelector('[data-react-workshop]')
);


// WEBPACK FOOTER //
// ./src/index.js